import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTickCircleinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "tickCirclePathA",
		d: "M32,0 C49.673112,0 64,14.326888 64,32 C64,49.673112 49.673112,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 Z M32,2 C15.4314575,2 2,15.4314575 2,32 C2,48.5685425 15.4314575,62 32,62 C48.5685425,62 62,48.5685425 62,32 C62,15.4314575 48.5685425,2 32,2 Z M42.3578112,19.9532579 L44.0467421,21.0244779 L29.3901741,44.1326435 L19.9298813,36.7608002 L21.1591998,35.1832147 L28.881,41.2 L42.3578112,19.9532579 Z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "tickCircleMaskB",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#tickCirclePathA" })
			}),
			/* @__PURE__ */ _jsx("use", {
				fill: "currentColor",
				fillRule: "nonzero",
				xlinkHref: "#tickCirclePathA"
			}),
			/* @__PURE__ */ _jsx("g", {
				fill: "currentColor",
				mask: "url(#tickCircleMaskB)",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 64,
					height: 64
				})
			})
		]
	})]
});
export default SvgTickCircleinline;
